'use client';
import Image from 'next/image';
import { IcChevronRight, Typography, theme } from '@bgzt/ui';

import styles from './ProductShopEntryBanner.module.css';
import { findShop } from '~/utils/shop-service';
import { LinkByEnvironment } from '~/components';

type Props = {
  shopId?: string;
};
export const ProductShopEntryBanner = ({ shopId }: Props) => {
  const shop = findShop(shopId);
  if (!shopId || !shop) {
    return null;
  }

  const HighlightedText = ({ text, highlightedWord }: { text: string; highlightedWord: string }) => {
    const parts = text.split(new RegExp(`(${highlightedWord})`));

    return (
      <>
        {parts.map((part, index) =>
          part === highlightedWord ? (
            <Typography key={index} variant={'C1'} color={'gray-900'} as="span">
              {part}
            </Typography>
          ) : (
            <span key={index}>{part}</span>
          ),
        )}
      </>
    );
  };

  return (
    <LinkByEnvironment href={`/shop/${shopId}`} target="_blank">
      <div className={styles.container}>
        <div className={styles.content}>
          <Image
            src={shop.images.logo}
            alt={`${shop.shopNameKor} 로고`}
            width={28}
            height={28}
            unoptimized
            className={styles.logo}
          />
          <Typography variant={'L10'} color={'gray-800'}>
            <HighlightedText text={shop.bannerDesc} highlightedWord={shop.shopNameKor} />
          </Typography>
        </div>
        <IcChevronRight size={12} fill={theme.colors['gray-500']} />
      </div>
    </LinkByEnvironment>
  );
};
